import _ from 'lodash';
import moment from 'moment-timezone';

import { LeadEmailCampaignSchedule } from './lead-email-campaign-schedule';
import { UserNotificationCategoryCampaign } from './user-notification-category-campaign';

export class LeadEmailCampaign {
	public id: number;
	public leadId: number;
	public userNotificationCategoryCampaignId: number;
	public recipients: string;
	public message: string;
	public details: string;
	public isDismissed: boolean;
	public overrideAnchorDate: Date;

	public leadEmailCampaignSchedules: LeadEmailCampaignSchedule[];
	public userNotificationCategoryCampaign: UserNotificationCategoryCampaign;

	constructor(leadEmailCampaign?: Partial<LeadEmailCampaign>) {
		Object.assign(this, leadEmailCampaign);

		this.leadEmailCampaignSchedules = this.leadEmailCampaignSchedules
			? this.leadEmailCampaignSchedules.map(l => new LeadEmailCampaignSchedule(l))
			: this.leadEmailCampaignSchedules;
		this.userNotificationCategoryCampaign = this.userNotificationCategoryCampaign
			? new UserNotificationCategoryCampaign(this.userNotificationCategoryCampaign)
			: this.userNotificationCategoryCampaign;
		this.overrideAnchorDate = this.overrideAnchorDate
			? new Date(moment(this.overrideAnchorDate).format('MMM DD, YYYY 00:00:00 a'))
			: this.overrideAnchorDate;
	}

	get fromDate() {
		return _.minBy(
			this.leadEmailCampaignSchedules.map(l => l.date),
			l => l.valueOf(),
		);
	}

	get toDate() {
		return _.maxBy(
			this.leadEmailCampaignSchedules.map(l => l.date),
			l => l.valueOf(),
		);
	}

	get hasUpcomingSchedule() {
		return moment().isBefore(moment(this.toDate));
	}
}
